// extracted by mini-css-extract-plugin
module.exports = {"Gbook":"Gbook--ibkc0","header":"header--d7Sen","headerLeft":"headerLeft--KFvdc","headerRight":"headerRight--2M6Tw","content":"content--35gS-"};